import axios from 'axios';
import END_POINT from '../config/endpoints.constants';
import { getErrorMessage } from '../customer-call-sdk/lib/API';
import { VriAPIResponse, VriAPIResult } from '../types';
import { B2BUsageReport } from '../types/B2BUsageReport.type';

export interface GetBillingCodesByEmailResult extends VriAPIResult {
    data?: string[];
}

export interface GetBillingCodesByEmailResponse extends VriAPIResponse {
    data: string[];
}

export async function getBillingCodesByEmail(email: string) {
    const result: GetBillingCodesByEmailResult = {};
    try {
        const { data: responseData } = await axios.post<GetBillingCodesByEmailResponse>(
            END_POINT.Get_BILLING_CODE_BY_EMAIL,
            { email },
        );
        if (responseData && responseData.code === 0) {
            result.data = responseData.data;
        } else if (responseData && responseData.code === 2) {
            result.error = responseData.message;
            result.data = responseData.data ?? null;
        } else {
            result.error = responseData.message;
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}

export interface GetBusinessUsageReportPayload {
    limit: number;
    offset: number;
    billingCode: string;
    fromDate: string;
    toDate: string;
}
export interface GetBusinessUsageReportResult extends VriAPIResult {
    data?: { totalCount: number; totalPages: number; objects: B2BUsageReport[] };
}

export interface GetBusinessUsageReportResponse extends VriAPIResponse {
    data: { totalCount: number; totalPages: number; objects: B2BUsageReport[] };
}

export async function getBusinessUsageReport(payload: GetBusinessUsageReportPayload) {
    const result: GetBusinessUsageReportResult = {};
    try {
        const { data: responseData } = await axios.post<GetBusinessUsageReportResponse>(
            END_POINT.BUSINESS_USAGE_REPORT,
            payload,
        );
        if (responseData && responseData.code === 0) {
            result.data = responseData.data;
        } else if (responseData && responseData.code === 2) {
            result.error = responseData.message;
            result.data = responseData.data ?? null;
        } else {
            result.error = responseData.message;
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
